type ParsedUserName = {
  firstName: string;
  lastName: string;
};

/**
 * Parses a full name string into first and last name components.
 * If no space is found, uses the entire name as firstName.
 * If name is empty or undefined, returns fallback values.
 *
 * @param fullName - The full name string to parse (e.g., "Maya Chen")
 * @returns An object with firstName and lastName
 *
 * @example
 * ```ts
 * parseUserName("Maya Chen") // { firstName: "Maya", lastName: "Chen" }
 * parseUserName("Maya") // { firstName: "Maya", lastName: "" }
 * parseUserName("") // { firstName: "Cardholder", lastName: "" }
 * ```
 */
export const parseUserName = (fullName?: string | null): ParsedUserName => {
  if (!fullName?.trim()) {
    return { firstName: 'Cardholder', lastName: '' };
  }

  const trimmedName = fullName.trim();
  const spaceIndex = trimmedName.indexOf(' ');

  if (spaceIndex === -1) {
    return { firstName: trimmedName, lastName: '' };
  }

  return {
    firstName: trimmedName.substring(0, spaceIndex),
    lastName: trimmedName.substring(spaceIndex + 1),
  };
};
